import { z } from 'zod';
import { spouseInfoSchema, validateSimpleMarriageFields } from '../spouseInfo';
import { addressSchema } from '../common/addressSchema';

export const mailingAddressBaseSchema = z.object({
    address: addressSchema,
    isMarried: z.boolean().optional(),
    spouseContact: z.string().optional(),
    spouseInfo: spouseInfoSchema.optional(),
});

const simpleSpouseNameFields = {
    spouseFirstName: z.string().optional(),
    spouseLastName: z.string().optional(),
};

export const mailingAddressSchema = mailingAddressBaseSchema
    .extend(simpleSpouseNameFields)
    .superRefine((data, ctx) => {
        validateSimpleMarriageFields(data, ctx);
    });

export const createSchema = () =>
    z.object({
        /*
         * Have to use superRefine with a separate function to enable sharing the schema
         * see: https://github.com/colinhacks/zod/issues/2474
         */
        primaryApplicant: mailingAddressSchema,
        workPerformedAtAddress: z.boolean(),
    });

// Default schema for backward compatibility
export const schema = createSchema();

export type MailingAddressData = z.infer<typeof schema>;
